"use strict";

var colors = require('./colors');
var breakpoints = require('./breakpoints');
var type = require('./type');
var spacing = require('./spacing');
var components = require('./components');
var flattenedVariables = Object.assign({}, colors.canonical, colors.canonicalHsl, colors.transparent, colors.functional, type, spacing, components);
var flattenedBreakpoints = Object.assign({}, breakpoints.canonical, breakpoints.functional);
var reduceToValues = function reduceToValues(variableGroup) {
  return Object.keys(variableGroup).reduce(function (accum, variableName) {
    accum[variableName] = variableGroup[variableName].value;
    return accum;
  }, {});
};
module.exports = {
  documentationVariables: flattenedVariables,
  variables: reduceToValues(flattenedVariables),
  documentationBreakpoints: flattenedBreakpoints,
  breakpoints: reduceToValues(flattenedBreakpoints),
  canonicalBreakpoints: reduceToValues(breakpoints.canonical)
};